import MasonryGrid from "../MasonryGrid";
import { SessionReportCardSkeleton } from "./SessionReportCardSkeleton";

const CARD_SLOTS = ["card-a", "card-b"] as const;

export const SessionReportCardsSectionSkeleton = () => {
	return (
		<MasonryGrid>
			{CARD_SLOTS.map((slotId) => (
				<SessionReportCardSkeleton key={slotId} />
			))}
		</MasonryGrid>
	);
};
